// extracted by mini-css-extract-plugin
module.exports = {"filtersWrapper":"DepartmentFilters_filtersWrapper__qrlu-","filterCTA":"DepartmentFilters_filterCTA__1Xlc3"};